'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('../resource'),
    PreisResource = _require2.PreisResource;

module.exports.Preis = function (_BaseEntity) {
  _inherits(Preis, _BaseEntity);

  _createClass(Preis, null, [{
    key: '__name__',
    value: function __name__() {
      return 'preis';
    }
  }]);

  function Preis(data) {
    _classCallCheck(this, Preis);

    var _this = _possibleConstructorReturn(this, (Preis.__proto__ || Object.getPrototypeOf(Preis)).call(this));

    _this._entityName = 'de.ul.fob.domain.Preis';
    _this.hatPreisgeld = null;
    _this.namePreis = null;
    _this.vergebenDurch = null;
    _this.verleihungsJahr = null;

    _this.organisationseinheit = null;
    _this.preisBezeichnung = null;
    _this.preisTraeger = null;
    _get(Preis.prototype.__proto__ || Object.getPrototypeOf(Preis.prototype), 'init', _this).call(_this, data);
    return _this;
  }

  _createClass(Preis, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'hatPreisgeld', 'namePreis', 'vergebenDurch', 'verleihungsJahr'],
        links: ['organisationseinheit', 'preisBezeichnung', 'preisTraeger']
      });
    }
  }, {
    key: 'fetchOrganisationseinheit',
    value: function fetchOrganisationseinheit() {
      return _get(Preis.prototype.__proto__ || Object.getPrototypeOf(Preis.prototype), 'genericResolve', this).call(this, 'organisationseinheit');
    }
  }, {
    key: 'fetchPreisBezeichnung',
    value: function fetchPreisBezeichnung() {
      return _get(Preis.prototype.__proto__ || Object.getPrototypeOf(Preis.prototype), 'genericResolve', this).call(this, 'preisBezeichnung');
    }
  }, {
    key: 'fetchPreisTraeger',
    value: function fetchPreisTraeger() {
      return _get(Preis.prototype.__proto__ || Object.getPrototypeOf(Preis.prototype), 'genericResolve', this).call(this, 'preisTraeger');
    }
  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(Preis.prototype.__proto__ || Object.getPrototypeOf(Preis.prototype), 'genericResolve', this).call(this, 'organisationseinheit'), _get(Preis.prototype.__proto__ || Object.getPrototypeOf(Preis.prototype), 'genericResolve', this).call(this, 'preisBezeichnung'), _get(Preis.prototype.__proto__ || Object.getPrototypeOf(Preis.prototype), 'genericResolve', this).call(this, 'preisTraeger')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof PreisResource === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(Preis.prototype.__proto__ || Object.getPrototypeOf(Preis.prototype), 'fetchQuery', this).call(this, PreisResource);
      }
    }
  }]);

  return Preis;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/preis.js
// module id = qbic
// module chunks = 0